import { gql } from '@apollo/client';

export const GET_MATCHING_RULES = gql`
  query GetMatchingRules {
    vm {
      configItem(key: "allow-volunteer-matching") {
        configItemId
        defaultValue
        configItemValue {
          flagValue
        }
      }
      matchingRules {
        matchingRuleId
        name
        enabled
        ruleOrder
        matchOnAvailability
        minimumScore
        action
        actionScheduling
        actionFrequency
        actionDurationMonths
        applicantRole {
          activityRoleId
          name
        }
        counterpartRole {
          activityRoleId
          name
        }
        program {
          programId
          name
        }
        sessions {
          matchingRuleSessionId
          name
          isFlexible
          position
          reportType {
            reportTypeId
            name
          }
        }
      }
    }
  }
`;
